const namespace = 'bravissimo/adestra';

export const SUBMIT_CONTACT_TO_ADESTRA_REQUEST = `${namespace}/SUBMIT_CONTACT_TO_ADESTRA_REQUEST`;
export const SUBMIT_CONTACT_TO_ADESTRA_SUCCESS = `${namespace}/SUBMIT_CONTACT_TO_ADESTRA_SUCCESS`;
export const SUBMIT_CONTACT_TO_ADESTRA_FAILURE = `${namespace}/SUBMIT_CONTACT_TO_ADESTRA_FAILURE`;
